import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=39aea90f"
import script from "./Authorize.vue?vue&type=script&lang=js"
export * from "./Authorize.vue?vue&type=script&lang=js"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=39aea90f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports